module.exports = __webpack_public_path__ + "static/media/BrownPapiPacify.1603d5d5.jpg";